import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
import { useElementSize } from '@vueuse/core';
import CustomTooltip from './CustomTooltip.vue';
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: 'OverflowTooltip'
    },
    __name: 'OverflowTooltip',
    props: {
        content: {},
        disabled: {
            type: Boolean
        },
        placement: {},
        trigger: {},
        showAfter: {},
        hideAfter: {},
        popperClass: {},
        closeOnClick: {
            type: Boolean
        }
    },
    setup (__props) {
        const props = __props;
        const triggerRef = ref(null);
        const isOverflowing = ref(false);
        let resizeObserver = null;
        // 使用 VueUse 的 useElementSize 来监听元素大小变化
        const { width, height } = useElementSize(triggerRef);
        // 检查内容是否溢出
        const checkOverflow = ()=>{
            const el = triggerRef.value;
            if (!el) return;
            const contentElement = el.firstElementChild || el;
            if (contentElement) {
                const isCurrentlyOverflowing = contentElement.scrollWidth > contentElement.clientWidth || contentElement.scrollHeight > contentElement.clientHeight;
                if (isOverflowing.value !== isCurrentlyOverflowing) {
                    isOverflowing.value = isCurrentlyOverflowing;
                }
            }
        };
        // 监听元素大小变化，重新检查溢出状态
        watch([
            width,
            height
        ], ()=>{
            checkOverflow();
        });
        onMounted(()=>{
            const el = triggerRef.value;
            if (el) {
                checkOverflow();
                // 使用 ResizeObserver 监听子元素大小变化
                resizeObserver = new ResizeObserver(checkOverflow);
                // 监听容器元素
                resizeObserver.observe(el);
                // 如果有子元素，也监听子元素
                if (el.firstElementChild) {
                    resizeObserver.observe(el.firstElementChild);
                }
            }
        });
        onBeforeUnmount(()=>{
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        });
        return (_ctx, _cache)=>{
            return _openBlock(), _createBlock(CustomTooltip, _mergeProps(_ctx.$attrs, {
                disabled: !isOverflowing.value
            }), {
                default: _withCtx(()=>[
                        _createElementVNode("div", {
                            ref_key: "triggerRef",
                            ref: triggerRef,
                            onMouseenter: checkOverflow
                        }, [
                            _renderSlot(_ctx.$slots, "default")
                        ], 544)
                    ]),
                content: _withCtx(()=>[
                        _renderSlot(_ctx.$slots, "content", {}, ()=>[
                                _createElementVNode("span", null, _toDisplayString(props.content), 1)
                            ])
                    ]),
                _: 3
            }, 16, [
                "disabled"
            ]);
        };
    }
});
